// extracted by mini-css-extract-plugin
export var active = "search-module--active--b27dc";
export var closeIcon = "search-module--close-icon--416a4";
export var searchForm = "search-module--search-form--096c3";
export var searchIcon = "search-module--search-icon--29c1f";
export var searchLabel = "search-module--search-label--8754a";
export var submit = "search-module--submit--abb95";